import pkg from '../../package.json';

export const ENV = {
    wordpressUrl: "https://nextgenrodeo.com/wp-content/APIUser.php",
    clientService: "https://nextgenrodeo-services-client.azurewebsites.net",
    // clientService: "http://localhost:5000",
    notificationService: "https://nextgenrodeo-services-notifications.azurewebsites.net",
    notifications: "http://nextgenrodeo-notifications.azurewebsites.net/",
    appVersion: pkg.version.replace('{','').replace('}',''),
    instrumentationKey: '38feaecc-fb11-4a63-ae16-1bf31c704b0c',
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts